if(!Util) { function Util () {} };

Util.addClass = function(el, className) {
  var classList = className.split(' ');
  el.classList.add(classList[0]);
  if (classList.length > 1) Util.addClass(el, classList.slice(1).join(' '));
};

Util.removeClass = function(el, className) {
  var classList = className.split(' ');
  el.classList.remove(classList[0]);
  if (classList.length > 1) Util.removeClass(el, classList.slice(1).join(' '));
};

Util.toggleClass = function(el, className, bool) {
  if(bool) Util.addClass(el, className);
  else Util.removeClass(el, className);
};

// File#: _3_looping-slideshow
// Usage: codyhouse.co/license
(function() {
  function clampNumber(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function createDebounced(fn, delayMs) {
    var timeoutId = null;
    return function () {
      var args = arguments;
      if (timeoutId) window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(function () {
        timeoutId = null;
        fn.apply(null, args);
      }, delayMs);
    };
  }

  function ensurePaginationTrack(navEl) {
    if (!navEl) return null;
    var existing = navEl.querySelector(':scope > .loop-slideshow__navigation-track');
    if (existing) return existing;

    // The navigation element is an <ol>. Keep valid markup by using an <ol> track.
    var track = document.createElement('ol');
    track.className = 'loop-slideshow__navigation-track';

    while (navEl.firstChild) {
      track.appendChild(navEl.firstChild);
    }
    navEl.appendChild(track);
    return track;
  }

  function computeBulletMetrics(bullets) {
    if (!bullets || bullets.length === 0) return null;

    var firstRect = bullets[0].getBoundingClientRect();
    if (!firstRect || firstRect.width <= 0) return null;

    var width = firstRect.width;

    if (bullets.length < 2) {
      return { width: width, gap: 0 };
    }

    var secondRect = bullets[1].getBoundingClientRect();
    var gap = Math.max(0, Math.round(secondRect.left - firstRect.right));

    return { width: width, gap: gap };
  }

  function normalizeBulletMargins(bullets) {
    if (!bullets) return;
    for (var i = 0; i < bullets.length; i++) {
      bullets[i].style.margin = '0';
    }
  }

  function setTrackStyles(trackEl, gap) {
    if (!trackEl) return;
    trackEl.style.display = 'flex';
    trackEl.style.flexWrap = 'nowrap';
    trackEl.style.alignItems = 'center';
    trackEl.style.justifyContent = 'flex-start';
    trackEl.style.gap = gap + 'px';
    trackEl.style.margin = '0';
    trackEl.style.padding = '0';
    trackEl.style.listStyle = 'none';
    trackEl.style.willChange = 'transform';
    trackEl.style.transition = 'transform 200ms ease';
  }

  function setWindowStyles(navEl, bulletWidth, gap, visible) {
    navEl.style.display = 'flex';
    navEl.style.flexWrap = 'nowrap';
    navEl.style.justifyContent = 'flex-start';
    navEl.style.alignItems = 'center';
    navEl.style.overflow = 'hidden';

    var windowWidth = visible * bulletWidth + Math.max(0, visible - 1) * gap;
    navEl.style.width = windowWidth + 'px';
  }

  function updateTrackPosition(activeIndex, trackEl, bulletStep, visible, total) {
    if (!trackEl) return;
    if (total <= visible) {
      trackEl.style.transform = 'translate3d(0, 0, 0)';
      return;
    }

    var maxStart = total - visible;
    var start = clampNumber(activeIndex - (visible - 1), 0, maxStart);
    var x = -start * bulletStep;
    trackEl.style.transform = 'translate3d(' + x + 'px, 0, 0)';
  }

  function setupLoopSlideshowPaginationWindow(obj, options) {
    var visible = (options && options.visible) || 5;
    var navEl = obj.element.getElementsByClassName('js-slideshow__navigation')[0];
    if (!navEl) return;

    var compute = function(activeIndex) {
      var bullets = obj.element.getElementsByClassName('js-slideshow__nav-item');
      if (!bullets || bullets.length === 0) return;

      var trackEl = ensurePaginationTrack(navEl);
      if (!trackEl) return;

      // Ensure bullets are laid out horizontally before measuring.
      setTrackStyles(trackEl, 0);

      // Measure before normalizing margins so we can preserve the visual gap.
      var metrics = computeBulletMetrics(bullets);
      if (!metrics) return;

      // Keep CSS margins for bullet spacing (avoids relying on flex gap support).
      // We only use the measured gap to compute the correct track translation step.

      // Reset any previously forced width if there are few bullets.
      if (bullets.length <= visible) {
        navEl.style.width = '';
        navEl.style.overflow = '';
        navEl.style.justifyContent = '';
        trackEl.style.transform = 'translate3d(0, 0, 0)';
        return;
      }

      setWindowStyles(navEl, metrics.width, metrics.gap, visible);
      updateTrackPosition(activeIndex, trackEl, metrics.width + metrics.gap, visible, bullets.length);
    };

    var getActive = function() {
      return obj.slideshowObj && typeof obj.slideshowObj.selectedSlide === 'number' ? obj.slideshowObj.selectedSlide : 0;
    };

    // Wait for navigation to be created and for layout to settle.
    if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          compute(getActive());
        });
      });
    } else {
      compute(getActive());
    }

    obj.element.addEventListener('newItemSelected', function(event){
      var activeIndex = typeof event.detail === 'number' ? event.detail : 0;
      compute(activeIndex);
    });

    if (typeof window !== 'undefined' && 'ResizeObserver' in window) {
      var ro = new ResizeObserver(createDebounced(function () {
        compute(getActive());
      }, 50));
      ro.observe(navEl);
    } else if (typeof window !== 'undefined') {
      var onResize = createDebounced(function () {
        compute(getActive());
      }, 100);
      window.addEventListener('resize', onResize, { passive: true });
    }
  }

  var LoopSlideshow = function(element) {
    this.element = element;
    this.slideshowObj = false;
    this.navItems = this.element.getElementsByClassName('js-slideshow__nav-item');
    this.autoplayInterval = 5000;
    this.autoplayPaused = false;
    this.fillingCSS = '--loop-slideshow-filling';
    this.pauseBtnClass = 'js-loop-slideshow__pause-btn';
    this.pauseBtn = this.element.getElementsByClassName(this.pauseBtnClass);
    this.animating = false;
    this.currentTime = false;

    initLoopSlideshow(this);
    initEvents(this);
  };

  function initLoopSlideshow(obj) {
    var autoplay = true,
			autoplayInterval = (obj.element.getAttribute('data-autoplay-interval')) ? obj.element.getAttribute('data-autoplay-interval') : obj.autoplayInterval,
			swipe = (obj.element.getAttribute('data-swipe') && obj.element.getAttribute('data-swipe') == 'on') ? true : false;
		obj.slideshowObj = new Slideshow({element: obj.element, navigation: true, autoplay : autoplay, autoplayInterval : autoplayInterval, swipe : swipe, navigationClass: 'loop-slideshow__navigation', navigationItemClass: 'loop-slideshow__nav-item', autoplayOnHover: true, autoplayOnFocus: true});
    // update autoplay interval
    obj.autoplayInterval = autoplayInterval;
    // filling effect for first item
    initFilling(obj, obj.slideshowObj.selectedSlide);
    // prevent pagination stacking on small screens when many items are present
    setupLoopSlideshowPaginationWindow(obj, { visible: 5 });
  };

  function initEvents(obj) {
    obj.element.addEventListener('newItemSelected', function(event){
      // new slide has been selected
      initFilling(obj, event.detail);
      toggleAutoplay(obj, false);
    });

    // custom click on image -> animate slideshow
    obj.element.addEventListener('click', function(event){
      if(event.target.closest('.js-loop-slideshow__pause-btn')) {
        toggleAutoplay(obj, !obj.autoplayPaused); // pause/play autoplay
        return;
      }

      var hitArea = event.target.closest('.js-loop-slideshow__hit-area');
      if(hitArea) {
        event.preventDefault();
        hitArea.classList.contains('js-loop-slideshow__hit-area--next') ? obj.slideshowObj.showNext() : obj.slideshowObj.showPrev();
        return;
      }

      if(event.target.closest('.js-slideshow__item')) {
        showNewSlide(obj, event);
      }
    });
  };

  function initFilling(obj, index) {
    cancelFilling(obj);

    for(var i = 0; i < obj.navItems.length; i++) {
      setFilling(obj.navItems[i], obj.fillingCSS, 0);
    }
    // trigger animation
    obj.currentTime = false;
    animateFilling(obj, index);
  };

  function cancelFilling(obj) {
    if(obj.animating) { // clear previous animation
      window.cancelAnimationFrame(obj.animating);
      obj.animating = false;
    }
  };

  function animateFilling(obj, index) {
    obj.animating = window.requestAnimationFrame(function(timestamp){
      if(!obj.currentTime) obj.currentTime = timestamp;
      var progress = timestamp - obj.currentTime;
      if(progress > obj.autoplayInterval) progress = obj.autoplayInterval;
      setFilling(obj.navItems[index], obj.fillingCSS, (progress/obj.autoplayInterval).toFixed(3));
      
      if(progress < obj.autoplayInterval) {
        animateFilling(obj, index);
      } else {
        // animation is over
        obj.animating = false;
        obj.currentTime = false;
      }
    });
  };

  function setFilling(element, property, value) {
    element.style.setProperty(property, value);
  };

  function showNewSlide(obj, event) {
    // check if we should go next or prev
    var boundingRect = obj.element.getBoundingClientRect(),
      isNext = event.clientX > boundingRect.left + boundingRect.width/2;

    isNext ? obj.slideshowObj.showNext() : obj.slideshowObj.showPrev();
  };

  function toggleAutoplay(obj, bool) {
    obj.autoplayPaused = bool;
    if(obj.autoplayPaused) {
      cancelFilling(obj);
      obj.slideshowObj.pauseAutoplay();
    } else {
      obj.slideshowObj.startAutoplay();
      initFilling(obj, obj.slideshowObj.selectedSlide);
    }
    if(obj.pauseBtn.length > 0) {
      // update btn appearance
      Util.toggleClass(obj.pauseBtn[0], 'btn-states--state-b', obj.autoplayPaused);
      // update pressed status 
      obj.autoplayPaused ? obj.pauseBtn[0].setAttribute('aria-pressed', 'true'): obj.pauseBtn[0].setAttribute('aria-pressed', 'false');
    }
  };

  //initialize the ThumbSlideshow objects
	var slideshow = document.getElementsByClassName('js-loop-slideshow');
  if( slideshow.length > 0 ) {
    for( var i = 0; i < slideshow.length; i++) {
      (function(i){
        new LoopSlideshow(slideshow[i]);
      })(i);
    }
  }
}());